import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qualifications-container"
}
const _hoisted_2 = {
  key: 1,
  class: "qualifications-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "buttons-container" }

import ResumeBase from "@/Layouts/ResumeBase/ResumeBase.vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import PreviewCard from "@/components/Resume/PreviewCard/PreviewCard.vue";
import { useResumeStore } from "@/store";
import { useRouter, useRoute } from "vue-router";
import { onMounted } from "vue";
import {
  convertToMonthYear,
  sortQualifications,
  focusOnMainContent,
} from "@/helpers";
import { onIonViewDidEnter } from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResumeQualifications',
  setup(__props) {

const resumeStore = useResumeStore();
const router = useRouter();
const route = useRoute();

onMounted(async () => {
  if (!resumeStore.resumeId) {
    await resumeStore.requestResume();
    if (!resumeStore.resumeId) {
      await resumeStore.createResume();
    }
  }
});
onIonViewDidEnter(() => {
  focusOnMainContent(route?.meta?.mainContentId);
});

function addQualification() {
  resumeStore.initQualificationForm();
  router.push({
    name: "ResumeQualificationDetail",
    params: { id: "new" },
  });
}

function editQualification(id: string) {
  resumeStore.initQualificationForm(id);
  router.push({
    name: "ResumeQualificationDetail",
    params: { id: id },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResumeBase, {
    breadcrumbs: [
      {
        label: _ctx.$t('resume.breadcrumbs.qualifications'),
      },
    ],
    mainContentId: "resume-qualifications-main-content",
    skipOnRouteBeforeLeave: true
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.qualificationsOverview.title")), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.qualificationsOverview.description")), 1)
    ]),
    "main-content": _withCtx(() => [
      (_unref(resumeStore).isResumeLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
              return _createElementVNode("div", {
                class: "qualification-item",
                key: item
              }, [
                _createVNode(PreviewCard, { isLoading: true })
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortQualifications)(
            _unref(resumeStore)?.resume?.qualifications
          ), (qual) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "qualification-item",
                key: qual.id
              }, [
                _createVNode(PreviewCard, {
                  id: qual.id,
                  title: qual.name,
                  isLoading: _unref(resumeStore).isResumeLoading,
                  "data-test": "preview-card",
                  "button-text": _ctx.$t('resume.qualificationsOverview.editButton'),
                  onClick: ($event: any) => (editQualification(qual.id))
                }, {
                  metadata: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(qual.institution), 1),
                    (qual.endDate)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(convertToMonthYear)(qual.endDate, _ctx.$t)), 1))
                      : _createCommentVNode("", true),
                    (!qual.isQualificationComplete)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("resume.qualificationsOverview.inProgressLabel")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  description: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(qual.highlights), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "title", "isLoading", "button-text", "onClick"])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AppButton, {
          size: "default",
          type: "primary",
          label: _ctx.$t('resume.qualificationsOverview.addQualificationBtnLabel'),
          ariaLabel: 
            _ctx.$t('resume.qualificationsOverview.addQualificationBtnLabel')
          ,
          "data-test": "add-qualification-btn",
          onClick: addQualification,
          class: "add-qualification-btn",
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"]),
        _createVNode(AppButton, {
          size: "default",
          type: "secondary",
          label: _ctx.$t('resume.qualificationsOverview.returnBtnLabel'),
          ariaLabel: _ctx.$t('resume.qualificationsOverview.returnBtnLabel'),
          "data-test": "return-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ResumeOverview' }))),
          class: "return-btn",
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"])
      ])
    ]),
    "resume-helper": _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
    _: 1
  }, 8, ["breadcrumbs"]))
}
}

})